import type { FieldStateReducer } from "@/components/form"
import {
  FormControl,
  FormField,
  FormGroup,
  FormLabel,
  FormMessage,
} from "@/components/form"
import { Input, InputProps } from "@/components/ui/input"
import { ComponentType } from "react"
import { Translate } from "../translate"

export type InputFieldProps = InputProps & {
  label: string
  name: string
  hideMessage?: boolean
  fieldStateReducer?: FieldStateReducer
  inputComponent?: ComponentType<InputProps>
}

export function InputField({
  label,
  fieldStateReducer,
  hideMessage,
  ref,
  inputComponent: InputComponent = Input,
  ...field
}: InputFieldProps) {
  return (
    <FormField name={field.name} fieldStateReducer={fieldStateReducer}>
      <FormGroup>
        <FormControl>
          <InputComponent {...field} ref={ref} />
        </FormControl>
        <FormLabel>
          <Translate i18nKey={label} />
        </FormLabel>
      </FormGroup>
      {!hideMessage && <FormMessage data-qa={"form-error-" + field.name} />}
    </FormField>
  )
}
